import { League } from '../../../../../types/sport';
import { getLeagueLogoUrl } from '../urls';
import { ESPN_HERO_BUNDESLIGA_TEAMS } from './BUNDESLIGA/bundesliga-teams';
import { ESPN_HERO_LALIGA_TEAMS } from './LALIGA/laliga-teams';
import { ESPN_HERO_LIGUE1_TEAMS } from './LIGUE1/ligue1-teams';
import { ESPN_HERO_PREMIER_LEAGUE_TEAMS } from './PREMIER-LEAGUE/premier-league-teams';

// color de disney
const DISNEY_DEFAULT_BG = '#17171B';

export const ESPN_HERO_LEAGUES: League[] = [
  {
    value: 'premier-league',
    label: 'Premier League',
    teams: ESPN_HERO_PREMIER_LEAGUE_TEAMS,
    imageUrl: getLeagueLogoUrl('premier-league'),
    backgroundColor: DISNEY_DEFAULT_BG
  },
  {
    value: 'la-liga',
    label: 'LALIGA',
    teams: ESPN_HERO_LALIGA_TEAMS,
    imageUrl: getLeagueLogoUrl('la-liga'),
    backgroundColor: DISNEY_DEFAULT_BG
  },
  {
    value: 'bundesliga',
    label: 'Bundesliga',
    teams: ESPN_HERO_BUNDESLIGA_TEAMS,
    imageUrl: getLeagueLogoUrl('bundesliga'),
    backgroundColor: DISNEY_DEFAULT_BG
  },
  {
    value: 'ligue1',
    label: 'Ligue 1',
    teams: ESPN_HERO_LIGUE1_TEAMS,
    imageUrl: getLeagueLogoUrl('ligue1'),
    backgroundColor: DISNEY_DEFAULT_BG
  },
  {
    value: 'serie-a',
    label: 'Serie A',
    disabled: true,
    imageUrl: getLeagueLogoUrl('serie-a'),
    //backgroundColor: DISNEY_DEFAULT_BG,
    teams: []
  },
  {
    value: 'champions-league',
    label: 'UEFA Champions League',
    disabled: true,
    imageUrl: getLeagueLogoUrl('champions-league'),
    backgroundColor: DISNEY_DEFAULT_BG,
    teams: []
  }
  /*   {
    value: 'liga-argentina',
    label: 'Copa de la Liga Profesional Argentina',
    disabled: true,
    imageUrl: getLeagueLogoUrl('liga-argentina'),
    backgroundColor: DISNEY_DEFAULT_BG,
    teams: []
  }, */
  /*   {
    value: 'europa-league',
    label: 'UEFA Europa League',
    disabled: true,
    imageUrl: getLeagueLogoUrl('europa-league'),
    backgroundColor: DISNEY_DEFAULT_BG,
    teams: []
  } */
];
